/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {webPasskeyUpsell} from '../api'

export const useMutationWebPasskeyUpsell = createReactQueryMutationHook('webPasskeyUpsell', webPasskeyUpsell)
